
<div style="position:absolute;top:20%;left:20%;">
  <img src="../../../../../assets/oddfellow_logga.PNG"/>
<video #video id="vid2" class="azuremediaplayer amp-default-skin" width="640" height="320" controls poster="../../../../assets/stavar_medium.jpg" data-setup='{"nativeControlsForTouch": false}'>
  <source src="{{videourl}}"/>
  <p class="amp-no-js">
      To view this video please enable JavaScript, and consider upgrading to a web browser that supports HTML5 video
  </p>
</video>
</div>




